export default __webpack_public_path__ + "static/media/Disclaimer.eb052724.pdf";